/**
 * Android bottom tab bar layout — iOS keeps native `UITabBar` via `MainTabNavigator.ios.tsx`.
 */
import { Platform } from 'react-native';

/** iOS menu/order bottom chrome reserve (safe area added separately in list padding helpers). */
export const IOS_MENU_FLOW_BOTTOM_OVERLAY_PADDING_BOTTOM = 105;

export const ANDROID_FLOATING_TAB_BAR_HEIGHT = 60;
/** Legacy names kept for imports; bar is flush to screen edges (no floating pill inset). */
export const ANDROID_FLOATING_TAB_BAR_BOTTOM_MARGIN = 0;
export const ANDROID_FLOATING_TAB_BAR_HORIZONTAL_MARGIN = 0;
export const ANDROID_FLOATING_TAB_BAR_BORDER_RADIUS = 0;
/** Space between tab bar top and menu/order bottom bars. */
export const ANDROID_FLOATING_TAB_BAR_CLEARANCE_GAP = 12;

/** Bottom inset inside macro / checkout bars — clears the bottom tab bar. */
export function getAndroidFloatingTabBarClearance(safe_area_bottom: number): number {
  return (
    ANDROID_FLOATING_TAB_BAR_BOTTOM_MARGIN +
    safe_area_bottom +
    ANDROID_FLOATING_TAB_BAR_HEIGHT +
    ANDROID_FLOATING_TAB_BAR_CLEARANCE_GAP
  );
}

/** Navigator `tabBarStyle.height` — reserves scene space for tab bar + home indicator. */
export function getAndroidFloatingTabBarLayoutHeight(safe_area_bottom: number): number {
  return ANDROID_FLOATING_TAB_BAR_BOTTOM_MARGIN + safe_area_bottom + ANDROID_FLOATING_TAB_BAR_HEIGHT;
}

/** Platform-aware bottom padding for menu macro bar + order checkout bar shells. */
export function getMenuFlowBottomOverlayPaddingBottom(safe_area_bottom: number): number {
  if (Platform.OS === 'android') {
    return getAndroidFloatingTabBarClearance(safe_area_bottom);
  }
  return IOS_MENU_FLOW_BOTTOM_OVERLAY_PADDING_BOTTOM;
}
